// this.$store.state.evento
import { serverTimestamp } from "firebase/firestore";

// EVENTOS
export const evento = class {
  constructor() {
    return {
      id: "",
      idGanador: "",
      imagen: {
        nombre: "",
        tipo: "",
        url: "",
      },
      nombre: "",
      descripcion: "",
      fecha: "",
      hora: "",
      estado: "Inactivo",
      registro: {
        estado: "Creado",
        idUsuario: "",
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
      },
    };
  }
};
